<template>
  <div class="redemptions-summary-table">
    <b-table :data="redemptions" :loading="isLoading">
      <template slot-scope="props">
        <b-table-column label="Data">{{ props.row.data | date }}</b-table-column>
        <b-table-column label="Qtd. Premiações">{{ (props.row.premiacoes || []).length }}</b-table-column>
        <b-table-column label="Total de Cargas" numeric>{{ props.row.total | currency }}</b-table-column>
        <b-table-column label="Opções">
          <button
            @click="viewDetails(props.row)"
            tag="button"
            type="button"
            v-app-button.icon-only
            title="Visualizar"
            v-tooltip.bottom="'Detalhamento Premiações'"
          >
            <b-icon size="is-small" icon="magnify"></b-icon>
          </button>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
            </p>
            <p>Nenhum registro encontrado.</p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
import ToastMixin from '@/mixins/ToastifyMixin';
import BuefyMixin from '@/mixins/BuefyMixin';
import { mapState } from 'vuex';

export default {
  name: 'redemptions-summary-table',
  mixins: [ToastMixin, BuefyMixin],
  computed: {
    ...mapState({
      isLoading: (state) => state.dashboard.loading,
      redemptions: (state) => state.dashboard.redemptions
    })
  },
  methods: {
    viewDetails(row) {
      this.$emit('onDetailClick', row);
    }
  }
};
</script>

<style lang="scss">
.sub-text {
  color: #aaa;
  font-size: 0.8em;
}

.b-table {
  box-shadow: 0px 2px 14px rgba(21, 23, 64, 0.03);
}
</style>
